var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createTheme } from "@mui/material";
import createBreakpoints from "@mui/system/createTheme/createBreakpoints";
import typography from "./typography";
var BREAKPOINTS = {
    xs: 0,
    sm: 648,
    md: 968,
    lg: 1248,
    xl: 1440,
};
var theme = createTheme({
    palette: {
        primary: {
            main: '#412382',
            contrastText: '#FFF'
        },
        secondary: {
            main: '#FECE00',
        },
        background: {
            paper: '#F8F8F8',
            default: "#FFF"
        },
        text: {
            primary: '#181818',
            secondary: '#46505A',
        },
    },
    typography: __assign({}, typography),
    breakpoints: createBreakpoints({
        values: BREAKPOINTS // needs to be done this way to apply breakpoints to generated css, if only a value is supplied here, most of the code works fine but there are some css glitches
    }),
    components: {
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '16px 16px 0 16px',
                    '@media (min-width: 600px)': {
                        padding: '24px 24px 0 24px',
                    }
                }
            }
        }
    }
});
export * from './icons';
export * from './themeExpansion';
export * from './flags';
export * from './clubs';
export default theme;
